// extracted by mini-css-extract-plugin
module.exports = {"container":"ArrowX_container__XDCmt","arrow":"ArrowX_arrow__sRdrJ"};